import { isImpersonationTab } from '../services/impersonationSession';

/**
 * True in an impersonation tab (#790), where every write is refused by the API. Components use it to hide or
 * disable write controls; the API, not this hook, is what keeps the session read-only.
 */
export const useReadOnly = () => isImpersonationTab();
